import React from 'react';
import { Spinner } from 'react-bootstrap';
import CustomSelect from '../../CustomSelect';
import Field from '../Field';
import styles from '../card.module.css';

/* Вкладка «Переподготовка и ПК» (п. 8 ТЗ).
   Год — выпадающий список, перечень лет приходит с сервера, по умолчанию
   выбран текущий. Смена года перезапрашивает оба плановых значения; сами
   значения не редактируются — это переключение отображения.

   Пока значения выбранного года грузятся, список лет остаётся на месте:
   иначе выбранный год пропадал бы с экрана вместе с телом вкладки. */

const Retraining = ({ years, year, plans, loading, onYearChange }) => (
  <div className={styles.pane}>
    <div className={styles.group}>
      План переподготовки и повышения квалификации постоянного состава
    </div>

    <div className={styles.yearField}>
      <CustomSelect
        title="На календарный год"
        width="100%"
        withoutAll
        options={years.map(item => ({ value: item, name: String(item) }))}
        value={year}
        setFieldValue={(name, value) => onYearChange(Number(value))}
        valuesName="year"
      />
    </div>

    {loading || !plans ? (
      <div className={styles.loader}>
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    ) : (
      <div className={styles.fform}>
        <Field
          label="План по переподготовке постоянного состава"
          value={plans.plan_retraining}
          mono
        />
        <Field
          label="План по повышению квалификации постоянного состава"
          value={plans.plan_qualification}
          mono
        />
      </div>
    )}
  </div>
);

export default Retraining;
